import BreadCrumb from 'Components/Common/BreadCrumb'
import React from 'react'
import { Card, Container, Input } from 'reactstrap'
import "./Variants.scss"

const Variantsdetailproducts = () => {
  return (
    <div>
          <div className="page-content">
      <Container fluid>
        <BreadCrumb title="Variant Detail" pageTitle="Ecommerce Products" /> 
        <Card>
          <div className="Main-Variant-Detail">
            <div className="heading">
              <h4>
                Blue
              </h4>
                <div className="form-check form-switch d-flex justify-content-center" >
                    <Input className="form-check-input toggleDV" type="checkbox"  role="switch" data-testing-id="availabilityToggle_EcommerceProductsIndex" />
                </div>
            </div>
             <div className="PKRBlueDV mt-3">
            <div className="pkr-section first-section">
               <h6>Price</h6>
                 <div className="mainFields firstChi mt-2">
      <div className="firstChilde">
        <div className="headindg">PKR</div>
        <input
          data-testing-id="Seller_ID"
          type="number"
          placeholder="1500"
        />
      </div>
    </div>
  </div>

  <div className="pkr-section second-section">
          <h6>Stock</h6>

   <div className="mainFields firstChi mt-2">
      <div className="firstChilde">
        {/* <div className="headindg"></div> */}
        <input
          data-testing-id="Seller_ID"
          type="number"
          placeholder="1500"
        />
      </div>
    </div>
  </div>
  
</div>
<div className="PKRBlueDV mt-3">
            <div className="pkr-section first-section">
               <h6>Special Price</h6>
                 <div className="mainFields firstChi mt-2">
      <div className="firstChilde">
        <div className="headindg">PKR</div>
        <input
          data-testing-id="Seller_ID"
          type="number"
          placeholder="1500"
        />
      </div>
    </div>
                 </div>
              </div>
              <div className='Special'>

            <h6>Special Price Period</h6>
              </div>

              <div className="Dflex">
                <div className="export-csv-Table">
                 <div className="date-picker-container">
                     <div className="input-wrapper">
                       <input type="date" id="from-date" placeholder="From Date" />
                      
                      </div>
                   </div>
                     <div className="date-picker-container">
                     <div className="input-wrapper">
                       <input type="date" id="from-date" placeholder="From Date" />
                      
                      </div>
                   </div>
                   


                       
                  </div>
                  
                  
              </div>
          </div>
        </Card>
     
        
      </Container>
</div>
    </div>
  )
}

export default Variantsdetailproducts
